import { Text } from '@chakra-ui/react';
import { FormatPrice } from 'components/localisation/FormatPrice';

interface PriceComparisonProps {
  after: number;
  before: number;
  quantity: number;
  total: number;
}

export function PriceComparison({
  after,
  before,
  quantity,
  total,
}: PriceComparisonProps) {
  return (
    <Text display="flex" flexWrap="wrap" columnGap="5xs" rowGap="2px">
      <FormatPrice
        size="detail"
        fontWeight="medium"
        color="gray.600"
        amount={after}
        afterText="/mo "
      />
      <FormatPrice
        size="detail"
        fontWeight="medium"
        color="blackAlpha.600"
        amount={before}
        beforeText=" vs. "
        afterText={after !== total ? ' · ' : undefined}
      />
      {after !== total && (
        <FormatPrice
          size="detail"
          fontWeight="medium"
          color="blackAlpha.600"
          amount={total * quantity}
          afterText=" total"
        />
      )}
    </Text>
  );
}
